export default {
    title: '鹊桥',
    route: {
        index: 'Index',
        network: 'network',
        interfaceGroup: 'interfaceGroup',
        interfaceLog: 'interfaceLog',
        apiProject: 'apiProject',
        apiDocument: 'apiDocument',
        apiSource: 'apiSource',
        apiPublicEnv: 'apiPublicEnv',
        apiSourceDetail: 'apiSourceDetail',
        apiDocumentEdit: 'apiDocumentEdit',
        apiPublicEnvDetail: 'apiPublicEnvDetail',
        interface: 'interface',
        router: 'router',
        server: 'server',
        security: 'security'
    }
};